function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyVc1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9824 17.4999L15.9908 19.5166L20.0158 15.4833",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9574 9.54172C16.5324 9.05006 17.4741 9.05006 18.0574 9.54172L19.3741 10.6751C19.6241 10.8917 20.0908 11.0667 20.4241 11.0667H21.8408C22.7241 11.0667 23.4491 11.7917 23.4491 12.6751V14.0917C23.4491 14.4167 23.6241 14.8917 23.8408 15.1417L24.9741 16.4584C25.4658 17.0334 25.4658 17.9751 24.9741 18.5584L23.8408 19.8751C23.6241 20.1251 23.4491 20.5917 23.4491 20.9251V22.3417C23.4491 23.2251 22.7241 23.9501 21.8408 23.9501H20.4241C20.0991 23.9501 19.6241 24.1251 19.3741 24.3417L18.0574 25.4751C17.4824 25.9667 16.5408 25.9667 15.9574 25.4751L14.6408 24.3417C14.3908 24.1251 13.9241 23.9501 13.5908 23.9501H12.1491C11.2658 23.9501 10.5408 23.2251 10.5408 22.3417V20.9167C10.5408 20.5917 10.3658 20.1251 10.1574 19.8751L9.03242 18.5501C8.54909 17.9751 8.54909 17.0417 9.03242 16.4667L10.1574 15.1417C10.3658 14.8917 10.5408 14.4251 10.5408 14.1001V12.6667C10.5408 11.7834 11.2658 11.0584 12.1491 11.0584H13.5908C13.9158 11.0584 14.3908 10.8834 14.6408 10.6667L15.9574 9.54172Z",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyVc1);
export default __webpack_public_path__ + "static/media/companyVc1.74d0439a9dcf8db5ece7f284370492e3.svg";
export { ForwardRef as ReactComponent };